import { render, staticRenderFns } from "./PatientDoctorAssignment.vue?vue&type=template&id=f4c7bbc8"
import script from "./PatientDoctorAssignment.vue?vue&type=script&lang=js"
export * from "./PatientDoctorAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports